export function remainingSeconds(deadline: string, serverNow: string, elapsed: number) { const end = Date.parse(deadline), now = Date.parse(serverNow); if (!Number.isFinite(end) || !Number.isFinite(now)) return null; return Math.max(0, Math.ceil((end - now - Math.max(0, elapsed)) / 1000)); }

export function todayInTimezone(timezone?: string, now = new Date()): string {
  const parts = new Intl.DateTimeFormat("en-CA", { timeZone: timezone || Intl.DateTimeFormat().resolvedOptions().timeZone, year: "numeric", month: "2-digit", day: "2-digit" }).formatToParts(now);
  const part = (type: string) => parts.find(value => value.type === type)?.value || "";
  return `${part("year")}-${part("month")}-${part("day")}`;
}

export function clientLogisticsActions(bag: { fulfillment_mode?: string | null; stage?: string | null; inspection?: { required?: boolean; status?: string | null } | null }): ("qc" | "china")[] {
  if (bag.fulfillment_mode !== "preorder_direct" || !["purchased", "inspection", "china_transit"].includes(bag.stage || "")) return [];
  if (bag.inspection?.required && bag.inspection.status === "pending") return ["qc"];
  if (bag.inspection?.status === "failed") return [];
  return !bag.inspection?.required || bag.inspection.status === "passed" ? ["china"] : [];
}

/** Inventory snapshots expose stable preparation codes, not user-facing copy. */
export function preparationBlocker(reason?: string | null): string | null {
  if (!reason) return null;
  return ({
    inspection_required: "Проведите осмотр в Москве и отметьте, нужны ли работы.",
    own_photos_required: "Добавьте собственные фотографии сумки.",
    explicit_price_required: "Укажите цену Telegram, чтобы передать сумку в Размещение.",
  } as Record<string,string>)[reason] || reason;
}
